export const lh = (sizePx, lineHeightPx) => lineHeightPx / sizePx;